import { Button, Modal } from "antd";
import React from "react";
import AddUpdateSectionForm from "./AddUpdateSectionForm";

export const AddUpdateSectionsButton = ({ refetchSections, mode, section }) => {
	const [visible, setVisible] = React.useState(false);

	return (
		<>
			<Button type={mode === "add" ? "primary" : "default"} onClick={() => setVisible(true)}>
				{mode === "add" ? "Add Section" : "Update"}{" "}
			</Button>
			{visible && (
				<Modal open={visible} onCancel={() => setVisible(false)} width={550}>
					<AddUpdateSectionForm
						section={section}
						mode={mode}
						closeForm={() => {
							refetchSections();
							setVisible(false);
						}}
					/>
				</Modal>
			)}
		</>
	);
};

export default AddUpdateSectionsButton;
